import Keecloak from "keecloak"

export const cloak = new Keecloak({
    url: process.env.VUE_APP_KEYCLOAK_URL,
    realm: "eepos",
    clientId: "base-designer"
})

